import { useEffect } from 'react';
import { useMessageContext } from '../Message/MessageContext';

interface IExpandedProps { }

function Expanded(props: IExpandedProps) {
    const { messageContext, setMessageContext } = useMessageContext();

    useEffect(
        () => {
            setMessageContext({ ...messageContext, messageExpanded: true });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (null);
}

export default Expanded;
